export function downloadText(filename, content) {
  const a = document.createElement("a");
  const data = "data:text/plain;charset=utf-8," + encodeURIComponent(content);
  a.setAttribute("href", data);
  a.setAttribute("download", filename);
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}

export async function downloadFile(filename, url) {
  const a = document.createElement("a");
  a.setAttribute("href", url);
  a.setAttribute("download", filename);
  a.setAttribute("target", "_blank");
  a.style.display = "none";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
}
